import React, { Component } from 'react'
import { connect } from 'react-redux'

import Attachments from 'components/Attachments'

import { attachmentPath } from 'selectors/attachments'

let select = (state, props) => ({
	path: attachmentPath(state, props.ownerID)
})

export class RightSide extends Component{
	render(){
		return(
			<div className="rightSide"
				style={{
					width: "50%"
				  , clear: "both"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "scroll"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "70px"
					  , overflow:"hidden"
					  , minHeight: "calc(100vh - 64px)"
					  , borderLeft: "1px solid rgba(0,0,0,0.3)"
					}}
				>
					<Attachments objectID={this.props.ownerID} path={this.props.path} removable={true} top={true}/>
				</div>

			</div>
		)
	}
}

export default connect(select)(RightSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/profile/RightSide.js